<template>
  <!-- 绑定新企业 -->
  <div class="login-container flex-b-r">
    <div class="login-body">
      <div class="title">绑定企业</div>
      <!-- 表单区 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div class="firmSign-Body">
          <!-- 左侧表单 -->
          <div class="firmSign">
            <!-- 表单名称 -->
            <div class="firmSign-title">
              <p v-for="(item, index) in TheName" :key="index">
                <span v-if="item.required != '1'" style="color: red">*</span
                >{{ item.title }}：
              </p>
            </div>
            <!-- 表单input框 / 选项 -->
            <div class="firmSign-content">
              <!-- 绑定企业名称 -->
              <div class="input-place">
                <el-form-item prop="firmName">
                  <el-select
                    v-model="ruleForm.firmName"
                    filterable
                    remote
                    placeholder="请输入"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    @change="pestChange"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 姓名框 -->
              <div class="input-place">
                <el-form-item prop="username">
                  <el-input
                    v-model="ruleForm.username"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 身份证号 -->
              <!-- <div class="input-place">
                <el-form-item prop="idCard">
                  <el-input
                    v-model="ruleForm.idCard"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
              </div> -->
            </div>
          </div>
          <!-- 右侧表单 -->
          <div class="firmSign">
            <!-- 表单名称 -->
            <div class="firmSign-title">
              <p v-for="(item, index) in TheNameRight" :key="index">
                <span v-if="item.required != '1'" style="color: red">*</span
                >{{ item.title }}
              </p>
            </div>
            <!-- 表单input框 / 选项 -->
            <div class="firmSign-content">
              <!-- 头像 -->
              <!-- <div class="avatar_box">
                <Avatar @handleAvatarTxUrl="handleAvatarTxUrl"></Avatar>
              </div> -->
              <!-- 身份证 -->
              <div class="input-place">
                <el-form-item prop="idCard">
                  <el-input
                    v-model="ruleForm.idCard"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 职位选择 -->
              <div class="input-place">
                <el-form-item prop="position">
                  <el-select
                    v-model="ruleForm.position"
                    placeholder="请选择职位"
                  >
                    <el-option
                      v-for="item in optionsFirm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 按钮 -->
      <div class="SignBtn">
        <div class="btn-box">
          <p class="firm-clickable" @click="$router.push('/AllFirm')">返回</p>
          <!-- 点击按钮时有 提示 -->
          <el-tooltip
            class="item"
            effect="dark"
            content="申请后请联系该公司管理员在公司后台管理系统进行审核"
            placement="top-start"
          >
            <p class="firm-clickable" @click="handelSkipHomepage('ruleForm')">绑定新企业</p>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="BaseMap"></div>
  </div>
</template>

<script>
import {
  bindCompany, // 企业登录-申请绑定公司
  getUserInfoByPhone, // 根据手机号查询用户信息
} from "../../assets/api/firm/firmLogin";
// 封装的表单验证
import { vxRule } from "../../../untils/FormValidation/validate-form";
// 引入头像组件
import Avatar from "../../components/AvatarToken.vue";
import {
  postGetCompanyListByName, // 根据公司名搜索公司
} from "../../assets/api/index";
export default {
  // 组件名称
  name: "firmsign",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    // Avatar
  },
  // 组件状态值
  data() {
    return {
      TheName: [{ title: "绑定企业名称" }, { title: "姓名" }], //表单名
      TheNameRight: [
        // { title: "头像：", required: "1" },
        // { required: "1" },
        { title: "身份证号：" },
        { title: "职位：" },
      ], //表单名
      input: "", // 输入框v-model
      optionsFirm: [
        {
          value: "0",
          label: "总经理(总裁)",
        },
        {
          value: "1",
          label: "总经理",
        },
        {
          value: "2",
          label: "人力资源总监",
        },
        {
          value: "3",
          label: "财务总监(CFO)",
        },
        {
          value: "4",
          label: "销售总监",
        },
        {
          value: "5",
          label: "市场总监(CMO)",
        },
        {
          value: "6",
          label: "生产总监",
        },
        {
          value: "7",
          label: "运营总监",
        },
        {
          value: "8",
          label: "技术总监",
        },
        {
          value: "9",
          label: "总经理助理",
        },
        {
          value: "10",
          label: "人力资源",
        },
        {
          value: "11",
          label: "人力资源助理",
        },
        {
          value: "12",
          label: "人力资源专员",
        },
        {
          value: "13",
          label: "招聘主管",
        },
        {
          value: "14",
          label: "客服主管",
        },
        {
          value: "15",
          label: "客服助理",
        },
      ], // 下拉框的选项
      // 添加屏蔽公司检索公司名要用到的
      options: [],
      value: [],
      list: [],
      loading: false, // 添加屏蔽公司加载状态
      states: [], // 添加屏蔽公司 公司数据列表
      shieldObj: {}, // 添加屏蔽公司 接口所需数据
      ruleForm: {
        id: "",
        firmName: "", // 企业名称
        companyId: "", // 企业id 通过根据名称搜索企业获取
        username: "", //姓名
        idCard: "", //身份证号
        position: "", // 职位
        phone: "", // 从登陆页拿的手机号 用于获取
        // userImg: "",
      },
      rules: {
        firmName: vxRule(true, "", ["blur", "change"], "请选择绑定企业名称"),
        username: vxRule(true, "", ["blur", "change"], "请输入姓名"),

        position: vxRule(true, "", ["blur", "change"], "请选择职位"),
        idCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
      }, // 表单验证
    };
  },
  watch: {},

  // 组件初始化
  created() {
    this.getUserInfoByPhone();
    console.log(this.$route.query, "this.$route.query.companyName");
    if (
      this.$route.query.companyName != "" &&
      this.$route.query.companyName != undefined
    ) {
      this.ruleForm.firmName = this.$route.query.companyName;
      this.ruleForm.companyId = this.$route.query.companyId;
      this.ruleForm.position = this.$route.query.positionEnumId;
      this.ruleForm.idCard = this.$route.query.idCard;
      this.ruleForm.username = this.$route.query.username;
      this.$router.push({ query: {} });
    }
  },
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    // 上传头像
    handleAvatarTxUrl(val) {
      // this.ruleForm.userImg = val;
    },
    // 根据手机号查询用户信息
    getUserInfoByPhone() {
      this.ruleForm.phone = localStorage.getItem("phone");
      getUserInfoByPhone({ data: localStorage.getItem("phone") }).then(
        (res) => {
          if (
            res.code == 0 &&
            res.data &&
            res.data.idCard != "" &&
            res.data.idCard != null
          ) {
            this.ruleForm.username =
              res.data.username != null ? res.data.username : "";
            this.ruleForm.idCard =
              res.data.idCard != null ? res.data.idCard : "";
            this.ruleForm.id = res.data.id != null ? res.data.id : "";
          }
        }
      );
    },
    // 选择 企业名称完毕 获取需要的值sessionStorage.getItem("phone")
    pestChange(val) {
      this.ruleForm.phone = localStorage.getItem("phone");
      var data = {};
      data.data = {
        name: val,
      };
      if (val != "") {
        postGetCompanyListByName(data, 1, 10).then((res) => {
          // 给添加屏蔽公司接口所需的数据赋值
          this.ruleForm.companyId = res.data.list[0].id;
        });
      }
    },
    // 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取企业名称放入this.states
      var data = {};
      data.data = {
        name: query,
      };
      // 调用 获取企业名称接口
      if (query != "") {
        await postGetCompanyListByName(data, 1, 10).then((res) => {
          this.states = res.data.list;
          this.list = this.states.map((item) => {
            return {
              value: `${item.name}`,
              label: `${item.name}`,
              id: `${item.id}`,
            };
          });
        });
        // 组件 自带远程搜索的函数
        if (query !== "") {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options = this.list.filter((item) => {
              return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options = [];
        }
      }
    },
    handelSkipHomepage(formName) {
      console.log(this.ruleForm);
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            data: this.ruleForm,
          };
          bindCompany(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "已提交审核");
              this.$router.push("/AllFirm");
            } else {
              // this.$tool.PromptBox("error", res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  border: 1px solid #409eff ;
}
/deep/.el-form-item__content {
  width: 360px;
  margin-left: 0 !important;
}
// 调提示文字位置
/deep/.el-form-item__error {
  top: 40px;
}
/deep/ .el-date-editor--date {
  width: 360px !important;
}
/deep/.el-input__icon {
  font-size: 20px !important;
  margin-top: -3px;
}
// 主体内容
.login-container {
  min-width: 1230px !important;
  height: 100%;
  min-height: 740px;
  display: flex;
  flex-direction: column;
  background: #0054cc;
  background-image: linear-gradient(
    90deg,
    rgba(97, 144, 232, 0.5) 0%,
    rgba(167, 191, 232, 0.5) 99%
  );
  // 中心白色区域
  .login-body {
    min-width: 1200px;
    min-height: 520px !important;
    font-size: 16px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    // 标题
    .title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-top: 30px;
      font-family: FZLTCHJW--GB1-0;
      font-size: 18px;
      color: #409eff ;
      font-weight: 600;
      text-align: center;
      position: relative;
      p {
        width: 120px;
        height: 40px;
        background: #409eff ;
        border-radius: 5px;
        position: absolute;
        right: 30px;
        top: 0;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    // 企业注册表单主体
    .firmSign-Body {
      min-width: 1150px;
      min-height: 240px;
      margin-top: 40px;
      display: flex;
      // 左右表单的div
      .firmSign {
        width: 49%;
        height: 100%;
        display: flex;
        // 表单名称
        .firmSign-title {
          min-width: 180px;
          height: 100%;
          p {
            height: 35px;
            line-height: 35px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #333333;
            text-align: right;
            font-weight: 400;
            margin-top: 30px;
          }
          p:nth-child(1) {
            margin-top: 0;
          }
        }
        // 表单input框/选择
        .firmSign-content {
          min-width: 350px;
          height: 100%;
          .input-place {
            width: 100%;
            height: 35px;
            margin-top: 30px;
            display: flex;
            position: relative;
            .Select-p {
              background: rgba(97, 144, 232, 0.27);
            }
            p {
              margin-left: 15px;
              width: 90px;
              height: 35px;
              line-height: 35px;
              background: #ffffff;
              border: 1px solid #409eff ;
              border-radius: 5px;
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #409eff ;
              text-align: center;
              font-weight: 400;
            }
            p:nth-child(1) {
              margin-left: 0;
            }
          }
          .input-place:nth-child(1) {
            margin-top: 0;
          }
          // 头像
          .avatar_box {
            width: 100%;
            height: 100px;
          }
          // 邮箱验证码
          .Code {
            width: 100%;
            height: 100px;
            margin-top: 30px;
            .Code-Acquire {
              width: 100%;
              height: 35px;
              margin-top: 15px;
              position: relative;
              p {
                position: absolute;
                top: 8px;
                right: 20px;
                border: none;
                background-color: transparent;
                z-index: 0;
                font-size: 12px;
                color: #409eff ;
                text-align: center;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
  // 底图
  .BaseMap {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/imgs/img/beijinglou@2x.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
// 按钮区
.SignBtn {
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 60px;
  z-index: 99;
  .btn-box {
    width: 300px;
    height: 40px;
    margin: auto;
    display: flex;
    p {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin: auto;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #999999;
      border-radius: 5px;
      cursor: pointer;
    }
    p:nth-child(2) {
      background: #409eff ;
      border-radius: 5px;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
